import IRNewsAPI from './IRNewsAPI.js';
import IRNewsList from './IRNewsList.js';

const d = document;

/**
 * IRニュース年絞り込みリスト生成クラス
 */
export default class IRNewsYearList {
  /** 設定 */
  config = null;

  /** テンプレート */
  template = `
  <option value="#{year}">#{yearLabel}</span></label></option>
  `;

  /** select要素 */
  $select = null;

  /** リスト生成クラスのインスタンス */
  list = null;

  /** IRNewsAPI */
  api = null;

  /**
   * コンストラクタ
   * @param {Object} config 設定
   * @param {HTMLSelectElement} $select select要素
   * @param {IRNewsList} list リスト
   */
  constructor(config, $select, list) {
    this.config = config;
    this.$select = $select;
    this.list = list;
    this.onLoad = this.onLoad.bind(this);
    this.$select.addEventListener('change', this.onSelect.bind(this), { passive: true });

    // APIで全リストを呼び出して絞り込み年の範囲を探す
    this.api = new IRNewsAPI(config);
    this.api.on('load', this.onLoad);
    this.api.load({  doctype: 'all', len: 10000 });
  }

  /**
   * 日付データ文字列をDateに変換
   * @param {String} publishDate 日付データ
   * @return {Date} Date
   */
  toDate(publishDate) {
    const date = publishDate.split(' ')[0].split('/');
    const time = publishDate.match(/(\d{1,2}):(\d{2}):(\d{2})/);
    return new Date(
      date[0],
      parseInt(date[1], 10) - 1,
      parseInt(date[2], 10),
      parseInt(time[1], 10),
      parseInt(time[2], 10),
      parseInt(time[3], 10),
    );
  }

  /**
   * レンダリング
   * @param {Object} datas 記事リストデータ
   */
  rendar(datas) {
    const $select = this.$select;
    const currentSelectedIndex = $select.selectedIndex;

    const terms = [
      this.toDate(datas.items[0].publishDate).getFullYear(),
      this.toDate(datas.items[datas.items.length - 1].publishDate).getFullYear()
    ];
    const newestYear = Math.max(terms[0], terms[1]);
    const oldestYear = Math.min(terms[0], terms[1]);
    for (let year = newestYear; year >= oldestYear; year--) {
      $select.appendChild(this.rendarItem(year));
    }

    $select.selectedIndex = currentSelectedIndex;
  }

  /**
   * テンプレート埋め込み用変数リストを取得
   * @param {year} year 年
   * @return {Object} テンプレート埋め込み用変数リスト
   */
  getRendarProperties(year) {
    // テンプレート埋め込み用変数リスト
    const props = {
      year: year.toString(10),
      yearLabel: this.config.lang === 'ja' ? year + '年' : year,
    };

    return props;
  }

  /**
   * 年アイテムのレンダリング
   * @param {Number} year 年
   * @return {Element} リストアイテムの要素
   */
  rendarItem(year) {
    // テンプレート埋め込み用変数リスト
    const props = this.getRendarProperties(year);

    // テンプレートにデータを反映
    const $temp = d.createElement('select');
    $temp.innerHTML = this.template.replace(/#\{([^}]+)\}/g, (matched, property) => {
      return props[property]
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
      ;
    });

    const $el = $temp.children[0];
    return $el;
  }

  /**
   * 年選択
   * @param {String} yearStr 年
   */
  select(yearStr) {
    if (yearStr) {
      this.list.pdate = yearStr + '0101';
      this.list.fdate = yearStr + '1231';
    } else {
      this.list.pdate = '';
      this.list.fdate = '';
    }

    this.list.load();
  }

  /**
   * 記事リストの初回読み込みイベント
   * @param {Object} datas 記事リストデータ
   */
  onLoad(datas) {
    this.rendar(datas);
    this.api.off('load', this.onLoad);
  }

  /**
   * 選択イベント
   */
  onSelect() {
    const yearStr = this.$select.value;
    this.select(yearStr);
  }
}
